// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9695) return "static/chunks/089634ca-a47b80666bf3e76b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2810":"71c3bbcb0330bbe1","6043":"838e90bae471ac0d","9337":"45e27b8041db0da9"}[chunkId] + ".js";
};